import React, { useState } from "react";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, InputAdornment } from "@mui/material";
import "../../styles/header.css";
import BASE_URL from "../../components/config/appconfig";
import { useNavigate, Link } from "react-router-dom";
import SnackbarAlert from "../../components/snackbarAlert/snackbarAlert";
import usePageMeta from "../../utils/usePageMeta";

export default function AdminLogin() {
  usePageMeta(
    "Admin Login",
    "Administrator login for the Gospel and Church Health Framework.",
  );
  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // success | error | warning | info
  });

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const hideSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const clearField = (field) => {
    setFormData({
      ...formData,
      [field]: "",
    });
  };

  const handleAdminLogin = async () => {
    if (!formData.email || !formData.password) {
      showSnackbar("Please enter email and password", "warning");
      return;
    }

    try {
      const res = await fetch(`${BASE_URL}/api/admin/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (data.success) {
        localStorage.setItem("userData", JSON.stringify(data.user));
        showSnackbar("Login successful", "success");

        setTimeout(() => {
          navigate("/admin-dashboard");
        }, 1000);
      } else {
        showSnackbar(data.message || "Invalid admin credentials", "error");
      }
    } catch (error) {
      console.error("Login error:", error);
      showSnackbar("Server error. Please try again.", "error");
    }
  };

  return (
    <>
      <Box
        sx={{
          maxWidth: 700,
          mx: "auto",

          p: { xs: 3, sm: 5 },
          borderRadius: 2,
          mt: { xs: 4, sm: 8, md: 10 },
        }}
      >
        {/* Title */}
        <Typography variant="h4" className="title" mb={4}>
          The Gospel and Church Health Framework
        </Typography>
        <Typography
          variant="h5"
          mb={3}
          sx={{
            fontWeight: 600,
            color: "#1e293b",
            letterSpacing: "0.5px",
          }}
        >
          Admin Login
        </Typography>

        <Grid container spacing={4}>
          {/* Left column */}
          <Grid item size={{ xs: 12, md: 12 }}>
            <TextField
              focused
              fullWidth
              label="Email"
              variant="standard"
              placeholder="Enter admin email"
              value={formData.email}
              onChange={handleChange("email")}
              sx={{
                "& .MuiInputBase-input": {
                  paddingTop: "12px",
                },
              }}
              InputLabelProps={{
                className: "custom-label",
              }}
              InputProps={{
                endAdornment: formData.email && (
                  <InputAdornment position="end">
                    <IconButton onClick={() => clearField("email")}>
                      <CloseIcon
                        className="close-icon-signup"
                        fontSize="small"
                      />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Box mt={4}>
              <TextField
                focused
                fullWidth
                label="Password"
                type="password"
                variant="standard"
                placeholder="Enter password"
                value={formData.password}
                onChange={handleChange("password")}
                sx={{
                  "& .MuiInputBase-input": {
                    paddingTop: "12px",
                  },
                }}
                InputLabelProps={{
                  className: "custom-label",
                }}
                InputProps={{
                  endAdornment: formData.password && (
                    <InputAdornment position="end">
                      <IconButton onClick={() => clearField("password")}>
                        <CloseIcon
                          className="close-icon-signup"
                          fontSize="small"
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box
              sx={{
                height: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#64748b",
                fontSize: "14px",
              }}
            >
              Admins can login here to manage questions, view reports, and
              control Framework settings.
            </Box>
            {/* Login button */}

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={1}
            >
              <Button
                variant="contained"
                component={Link}
                to="/"
                sx={{
                  height: 48,
                  borderRadius: "10px",
                  padding: "8px 0px",
                  bgcolor: "#F9FAFB",
                  color: "#9AA4AF",

                  boxShadow: "none",
                  "&:hover": {
                    bgcolor: "#F9FAFB",
                    boxShadow: "none",
                  },
                }}
              >
                User Signup
              </Button>

              <Button
                variant="contained"
                onClick={handleAdminLogin}
                sx={{
                  width: 120,
                  height: 48,
                  borderRadius: "10px",
                  padding: "8px 16px",
                  bgcolor: "#ED1C2E",
                  color: "#fff",
                  textTransform: "none",
                  boxShadow: "none",
                  "&:hover": {
                    boxShadow: "none",
                  },
                }}
              >
                LOGIN →
              </Button>
            </Box>
            {/* <Box display="flex" justifyContent="center">
              <Button
                variant="contained"
                onClick={handleAdminLogin}
                sx={{
                  width: 120,
                  height: 48,
                  borderRadius: "10px",
                  padding: "8px 16px",
                  bgcolor: "#ED1C2E",
                  color: "#fff",
                  textTransform: "none",
                  boxShadow: "none",
                  "&:hover": {
                    boxShadow: "none",
                  },
                }}
              >
                LOGIN →
              </Button>
            </Box> */}
          </Grid>
        </Grid>
      </Box>
      <SnackbarAlert
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={hideSnackbar}
      />
    </>
  );
}
